var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Intro',{attrs:{"construction":false,"menuEnabled":true,"disabledParticles":false}}),_c('PublicationsComponent'),_c('WhoAmI2'),_c('Timeline2'),_c('b-progress',{staticClass:"progress is-hidden-mobile",attrs:{"type":"is-danger","value":_vm.progressValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }